'use es6';

import PropTypes from 'prop-types';
import { PopoverBodyLiteIcons } from '../../constants/popover';
import PopoverBodyLiteBase from '../PopoverBodyLiteBase';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.personalize.lite.${suffix}`;
const propTypes = {
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
function PersonalizePopoverBodyLite(props) {
  const {
    onEdit,
    onRemove
  } = props;
  const iconButtons = [{
    iconName: PopoverBodyLiteIcons.EDIT,
    onClick: onEdit
  }, {
    iconName: PopoverBodyLiteIcons.REMOVE,
    onClick: onRemove
  }];
  return /*#__PURE__*/_jsx("div", {
    "data-animated-popover": "preview",
    children: /*#__PURE__*/_jsx(PopoverBodyLiteBase, {
      "data-test-id": "personalize-popover-body-lite",
      iconButtons: iconButtons,
      i18nKey: i18nKey
    })
  });
}
PersonalizePopoverBodyLite.propTypes = propTypes;
PersonalizePopoverBodyLite.displayName = 'PersonalizePopoverBodyLite';
export default PersonalizePopoverBodyLite;